import { createGenericStore } from '@/stores/utils/genericStore.js'

// 1. Define your custom options
const userRoleStoreOptions = {
  state: () => ({
    // Add custom state properties here
    // e.g., customPropertyExample: null
  }),

  // Custom getters
  getters: {
    // e.g., myCustomGetter(state) { return ... }
  },

  // Custom actions
  actions: {
    // e.g., async myCustomAction() { ... }

  }
}

// 2. Create the store hook using your generic factory
export const useUserRoleStore = createGenericStore(
  'roles', // Base Store ID
  '/api/v1/user-roles', // API Endpoint
  userRoleStoreOptions // Pass in your custom logic
)
